// src/services/patientNotifications.js
//
// Patient bell (Patient Appointments Task 4). The patient is always the
// authenticated session; no patient id is ever sent.

import { api } from "../lib/patientApi";

const BASE = "/api/v1/patients/me/notifications";

export const patientNotificationsApi = {
  async list({ limit = 8, offset = 0, unreadOnly = false } = {}, { signal } = {}) {
    const res = await api.get(BASE, { params: { limit, offset, unread_only: unreadOnly || undefined }, signal });
    return res.data;
  },

  async unreadCount({ signal } = {}) {
    const res = await api.get(`${BASE}/unread-count`, { signal });
    return res.data;
  },

  async markRead(notificationId) {
    const res = await api.patch(`${BASE}/${notificationId}/read`);
    return res.data;
  },

  async markAllRead() {
    const res = await api.patch(`${BASE}/read-all`);
    return res.data;
  },

  async attention(displayTimezone, { signal } = {}) {
    const res = await api.get("/api/v1/patients/me/dashboard/appointment-attention", {
      params: displayTimezone ? { display_timezone: displayTimezone } : {},
      signal,
    });
    return res.data;
  },
};

export default patientNotificationsApi;
